<template>
  <NavBar />
  <router-view class="view" />
  <FootSection />
  <Footer />
</template>